export interface FindFirstIncompletePageParams<Slug extends string, FK extends string> {
  slugs: Slug[];
  getRequiredFieldsForSlug: (slug: Slug) => FK[];
  validatedFields: Partial<Record<Slug, FK[]>>;
}

function isPageComplete<Slug extends string, FK extends string>(
  required: FK[],
  validatedFields: Partial<Record<Slug, FK[]>>,
  slug: Slug,
): boolean {
  const validated = new Set(validatedFields[slug] ?? []);
  return required.every((field) => validated.has(field));
}

export function findFirstIncompletePage<Slug extends string, FK extends string>(
  params: FindFirstIncompletePageParams<Slug, FK>,
): Slug | null {
  const { slugs, getRequiredFieldsForSlug, validatedFields } = params;

  for (const slug of slugs) {
    const required = getRequiredFieldsForSlug(slug);
    if (required.length > 0 && !isPageComplete(required, validatedFields, slug)) {
      return slug;
    }
  }

  return null;
}
